// Robust, dependency-free clipboard copy.
//
// Tries the async Clipboard API first, then falls back to a hidden-textarea +
// execCommand("copy") for browsers/contexts where navigator.clipboard is
// unavailable or rejects. Returns true on success so callers can decide
// whether to show "Copied!" feedback — never silently no-ops without telling
// the caller.
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // fall through to the legacy path
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
